import React from 'react';
import { DatePicker, Space, Select } from 'antd';
import moment from 'moment';

const { Option } = Select;

export default function SearchFilter({ onDateChange, onAceptadaChange, loading }) {
  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };

  return (
    <Space style={{ marginBottom: 16 }}>
      <DatePicker
        onChange={(date) => onDateChange(date ? [date.startOf('day'), date.endOf('day')] : null)}
        format="DD/MM/YYYY"
        placeholder="Seleccione una fecha"
        disabled={loading}
        disabledDate={disabledDate}
      />
      <Select
        defaultValue={false}
        style={{ width: 200 }}
        onChange={onAceptadaChange}
        disabled={loading}
      >
        <Option value={false}>No Aceptadas</Option>
        <Option value={true}>Aceptadas</Option>
      </Select>
    </Space>
  );
}